// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"TabHeader_tabHeader__zRVv_","tab":"TabHeader_tab__3VG8Y","active":"TabHeader_active__Y2AqD","passive":"TabHeader_passive__uYQXc"};